import { IGroundEvent, IFlight, IBulkEventPayload, IAircraft, BulkActionType } from "@vmosolutions/oc-interfaces";
import { Auth, API } from "aws-amplify";
import { convertAircraftToFlightAircraft } from "src/redux/reducers/FlightTimelineReducer";

/**
 * A function that returns the aircraft ids of all the selected events
 * @param selectedEvents - events selected in timeline
 * @returns an array of the aircraft ids
 */
export const getAircraftIdsFromEvents = (selectedEvents: (IFlight | IGroundEvent)[]): string[] => {
  if (!selectedEvents) {
    return null;
  }
  return selectedEvents.reduce((unique, event) => {
    if (!unique.includes(event.aircraft?._id)) {
      unique.push(event.aircraft?._id);
    }
    return unique;
  }, []);
};

export interface ISwapAircraftResponseInterface {
  batchId1: string;
  batchId2: string;
}

/**
 *A function to call the bulk api to swap the aircraft on selected flights
 * @param selectedFlights - an array of timeline selected flights
 * @param aircraftIds -  an array of aircraft ids
 */
export const swapAircraftBySelectedEvent = async (
  selectedFlights: IFlight[] | IGroundEvent[],
  aircraftIds: string[],
  allAircrafts: IAircraft[],
  isFlight: boolean
): Promise<ISwapAircraftResponseInterface> => {
  //const allAircrafts = cloneDeep(getState().structures.customerStructure.aircraft);

  const flightsOnAircraft1: string[] = [];
  const flightsOnAircraft2: string[] = [];

  // find the full aircrafts
  const aircraft1: IAircraft = allAircrafts.find((aircraft: IAircraft) => aircraft._id === aircraftIds?.[0]);
  const aircraft2: IAircraft = allAircrafts.find((aircraft: IAircraft) => aircraft._id === aircraftIds?.[1]);

  if (!aircraft1 || !aircraft2) {
    return null;
  }

  //sort flights
  selectedFlights.forEach((event: IFlight | IGroundEvent) => {
    if (event.aircraft?._id === aircraft1._id) {
      flightsOnAircraft1.push(event._id);
    } else {
      flightsOnAircraft2.push(event._id);
    }
  });

  //swap first flight group
  const flightGroup1: IBulkEventPayload = {
    actionType: isFlight ? BulkActionType.UPDATE_FLIGHT : BulkActionType.UPDATE_GROUND_EVENT,
    batchIds: flightsOnAircraft1,
    payload: {
      aircraft: convertAircraftToFlightAircraft(aircraft2),
      aircraftConfiguration: aircraft2?.defaultConfig,
      updateType: "ReassignAircraft",
    },
  };

  //swap second flight group
  const flightGroup2: IBulkEventPayload = {
    actionType: isFlight ? BulkActionType.UPDATE_FLIGHT : BulkActionType.UPDATE_GROUND_EVENT,
    batchIds: flightsOnAircraft2,
    payload: {
      aircraft: convertAircraftToFlightAircraft(aircraft1),
      aircraftConfiguration: aircraft1?.defaultConfig,
      updateType: "ReassignAircraft",
    },
  };

  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  const result1 = await API.post("skytrains", "/bulk", {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
    body: flightGroup1,
  });

  const result2 = await API.post("skytrains", "/bulk", {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
    body: flightGroup2,
  });

  return {
    batchId1: result1.batchId,
    batchId2: result2.batchId,
  };
};
